import PATH from '@/router/path';

export const DMP_APPLICATION: ApplicationKey = 'dmp';
export const FREE_LEGAL_LINK_APPLICATION: ApplicationKey = 'free_legal_link';

export const getAvailableApplications = (context?: UserApplicationContext) => context?.available || [];

export const hasMultipleApplications = (context?: UserApplicationContext) =>
  getAvailableApplications(context).length > 1;

export const findApplication = (context: UserApplicationContext | undefined, key: ApplicationKey) =>
  getAvailableApplications(context).find((application) => application.key === key);

export const isPblApplicationPath = (pathname: string) => pathname.startsWith('/pbl/');

export const isPblApplicationContext = ({
  activeApplication,
  pathname,
}: {
  activeApplication?: ApplicationKey | null;
  pathname?: string;
}) => activeApplication === FREE_LEGAL_LINK_APPLICATION || Boolean(pathname && isPblApplicationPath(pathname));

export const shouldActivatePblApplication = ({
  isLogin,
  activeApplication,
  applications,
}: {
  isLogin: boolean;
  activeApplication?: ApplicationKey | null;
  applications?: UserApplicationContext;
}) => {
  if (!isLogin) return false;
  if (activeApplication === FREE_LEGAL_LINK_APPLICATION) return false;
  if (!applications) return true;

  return Boolean(findApplication(applications, FREE_LEGAL_LINK_APPLICATION));
};

export const getApplicationEntryUrl = (application?: UserApplicationItem | null) => {
  if (!application) return PATH.home.index;
  if (application.key === DMP_APPLICATION) return PATH.home.index;
  if (application.key === FREE_LEGAL_LINK_APPLICATION) return PATH.pbl.dashboard;

  return application.entry_url || PATH.home.index;
};

export const shouldSelectApplication = (context?: UserApplicationContext) =>
  Boolean(context?.requires_selection && hasMultipleApplications(context));
